module.exports = __webpack_public_path__ + "static/media/img7.3827e676.png";